import type { GridColDef, GridRowModel } from '@mui/x-data-grid-premium';
import { isEmpty } from 'lodash';
import { makeCol } from '../../common/utils/commonUtils';

export const valueGetter = (value, row: GridRowModel) => {
    return isEmpty(row) ? undefined : value;
};

// Factory for the common case: string column, sortable, with valueGetter


export const id = makeCol('ID', 'ID', { editable: false });
export const associatedTitle = makeCol('productionGroup', 'Associated Title', { editable: true });
export const summary = makeCol('summary', 'Summary', { editable: true });
export const noOfEpisodes = makeCol('noOfEpisodes', 'No. of Episodes', { editable: true });
export const seasonNo = makeCol('seasonNo', 'Season Number', { editable: true });
export const episodeNo = makeCol('episodeNo', 'Episode Number', { editable: true });
export const name = makeCol('publicTitle', 'Title', { editable: true });
export const AKA: GridColDef = makeCol('otherTitles', 'AKA', { editable: true });
export const productionType = makeCol('productionType', 'Type', { editable: true });
export const productionSubType = makeCol('productionSubType', 'Sub Type', { editable: true });
export const productionStatus = makeCol('productionStatus', 'Production Status', { editable: true });
export const projectStatus = makeCol('projectStatus', 'Project Status', { editable: true });
export const releaseDate = makeCol('releaseDate', 'Release Date', { editable: true });
export const releaseYear = makeCol('releaseYear', 'Release Year', { editable: true });
export const productionYears = makeCol('productionYears', 'Production Years', { editable: true });
export const genre = makeCol('genre', 'Genre', { editable: true });
export const tags = makeCol('tags', 'Tags', { editable: true });
export const runtime = makeCol('runtime', 'Runtime', { editable: true });
export const ownerOrganization = makeCol('ownerOrganizationName', 'Owner Organization', { editable: true });
export const statusNote = makeCol('currentStatusNote', 'Status Note', { editable: true });
export const projectOwnerContacts = makeCol('projectOwnerContactsString', 'Project Owners', { editable: true });
export const associatedPeople = makeCol('associatedPeopleString', 'Associated People', { editable: true });
export const associatedOrgs = makeCol('associatedOrgsString', 'Associated Organizations', { editable: true });
export const group = makeCol('group', 'Group', { editable: true });

export const productionImportColDefs: GridColDef[] = [
    id,
    name,
    AKA,
    productionType,
    productionSubType,
    genre,
    tags,
    summary,
    productionStatus,
    projectStatus,
    ownerOrganization,
    statusNote,
    projectOwnerContacts,
    associatedPeople,
    associatedOrgs,
    runtime,
    associatedTitle,
    releaseDate,
    releaseYear,
    productionYears,
    noOfEpisodes,
    seasonNo,
    episodeNo
];

export const importPlaceholder = `To enter data:
Simply type in this area, use Commas to separate production attributes and each production on a new line
Copy paste from Excel or other documents
Or drop an Excel or CSV file here
Rearrange the headers above to match the order of the data you entered`;

export const MATERIAL_COLUMN = 'materials';
export const PROJECT_STATUS_COLUMN = 'projectStatus';
export const PRODUCTION_TYPE_COLUMN = 'productionType';
export const GROUP_COLUMN = 'group';
export const KEY_ROLES_COLUMN = 'keyRoles';
export const ABOUT_COLUMN = 'about';